import { SIGNATURE_STATE_TOOLBAR_AGREE_TERMS } from '../SignatureStateToolbarConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SIGNATURE_STATE_TOOLBAR_AGREE_TERMS:
      return action.agree;
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src-react/SignatureStateToolbar/SignatureStateToolbarReducer/agreed.jsx